export const gameElementsShortList = {
  "1772230537866-86781-LNymX-item": {
    "status": "active",
    "opt_cat": "Relics of the Empire",
    "ts_uploaded": 1772230537866,
    "ts_created": 1772230537866,
    "opt_limitInd": 1,
    "type": "item",
    "path": "uotbcusu0m5fzmcvwk",
    "opt_visible": true,
    "opt_itemType": "collectible",
    "id": "1772230537866-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "A replica of an Aureus, a prestigious gold coin of the Roman Empire. These coins often depicted emperors, gods, or significant events, symbolizing wealth and power.",
    "opt_usable": true,
    "name": "Aureus Coin",
    "ts": 1774792591338,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c"
  },
  "1772230537867-86781-LNymX-item": {
    "opt_itemType": "contribution",
    "opt_visible": true,
    "path": "wlbliiikwiqq8zmsoe",
    "type": "item",
    "ts_created": 1772230537867,
    "ts_uploaded": 1772230537867,
    "status": "active",
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566213635-Contribution%20Item%20Template%20(1).png?alt=media&token=d9e40286-146c-4e09-b558-8e84449df37f",
    "ts": 1772566215848,
    "name": "Forum Collection: Outside Time",
    "desc": "Contribute 1,500 coins to give the entire class an opportunity to explore the outdoors!",
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537867-86781-LNymX-item",
    "opt_contributionGoal": 1500
  },
  "1772230537868-86781-LNymX-item": {
    "opt_itemType": "collectible",
    "ts_created": 1772230537868,
    "opt_limitInd": 1,
    "ts_uploaded": 1772230537868,
    "path": "buulld2uhkury9nhw2",
    "opt_visible": true,
    "type": "item",
    "opt_market": false,
    "opt_cat": "Relics of the Empire",
    "status": "active",
    "ts": 1774792601716,
    "name": "Fragment of a Roman Mosaic Tile",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_usable": true,
    "opt_preview": true,
    "desc": "A beautiful, colorful tessera from an ancient Roman mosaic, perhaps once part of a grand floor in a patrician villa. Each fragment tells a tiny piece of a larger story.",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537868-86781-LNymX-item"
  },
  "1772230537869-86781-LNymX-item": {
    "id": "1772230537869-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "opt_usable": true,
    "opt_preview": true,
    "desc": "For one day, you shall serve as the Magister's trusted assistant, helping to guide your fellow citizens and uphold order in the ludus (school)!",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "ts": 1774793209337,
    "name": "Magister's Legatus (Teacher's Helper for a Day)",
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553695485-Inventory%20Item%20(7).png?alt=media&token=720d5f6e-2ad6-4c50-82b8-de7fe34d7874",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_limitInd": 2,
    "ts_created": 1772230537869,
    "ts_uploaded": 1772230537869,
    "path": "ivuby781ayvjwfzeqq",
    "opt_visible": true,
    "type": "item",
    "opt_itemType": "inventory"
  },
  "1772230537870-86781-LNymX-item": {
    "opt_cat": "Relics of the Empire",
    "status": "active",
    "opt_market": true,
    "opt_itemType": "collectible",
    "type": "item",
    "path": "f4qmlefd3a7a9gl2bn",
    "opt_visible": true,
    "ts_uploaded": 1772230537870,
    "opt_limitInd": 1,
    "ts_created": 1772230537870,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537870-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
    "opt_marketPrice": 300,
    "name": "Miniature Legionary Helmet",
    "ts": 1774792744773,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_usable": true,
    "opt_preview": true,
    "desc": "A small, finely crafted replica of a Roman legionary's helmet. It represents the strength, discipline, and might of Rome's legendary armies.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040
  },
  "1772230537871-86781-LNymX-item": {
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "opt_market": true,
    "opt_itemType": "inventory",
    "path": "xwmh91xnfhdvp7dosf",
    "opt_visible": true,
    "type": "item",
    "ts_created": 1772230537871,
    "opt_limitInd": 2,
    "ts_uploaded": 1772230537871,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537871-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913",
    "opt_marketPrice": 100,
    "ts": 1774793230918,
    "name": "Otium Ludi (Free Time)",
    "opt_usable": true,
    "opt_preview": true,
    "desc": "Grant yourself extended otium (leisure time) beyond the usual bounds of the ludus. More time for gladiator games or chariot races outside!",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772230537872-86781-LNymX-item": {
    "status": "active",
    "opt_market": true,
    "opt_itemType": "realworld",
    "path": "kf8fjsuyfjoqdjamnb",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537872,
    "ts_created": 1772230537872,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537872-86781-LNymX-item",
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564438056-Real%20World%20Item%20Template%20(3).png?alt=media&token=7d3080c2-45c0-4339-98b5-5e4d4e484cde",
    "name": "One Pencil",
    "ts": 1772566551781,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "opt_usable": true,
    "desc": "Purchase this pencil",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040
  },
  "1772230537873-86781-LNymX-item": {
    "status": "active",
    "opt_market": true,
    "opt_itemType": "realworld",
    "path": "8to74sqtnv8s11c4pz",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537873,
    "ts_created": 1772230537873,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537873-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564911284-Real%20World%20Item%20Template%20(4).png?alt=media&token=53ab611a-9a04-4534-8c2a-08b15ed5631e",
    "opt_marketPrice": 50,
    "name": "One Piece of Candy",
    "ts": 1772566562625,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_usable": true,
    "desc": "Purchase one piece of candy from the candy box",
    "opt_preview": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040
  },
  "1772230537874-86781-LNymX-item": {
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_itemType": "inventory",
    "ts_created": 1772230537874,
    "opt_limitInd": 2,
    "ts_uploaded": 1772230537874,
    "type": "item",
    "path": "jrcu8vuy0747c8ee6f",
    "opt_visible": true,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537874-86781-LNymX-item",
    "ts": 1774793258707,
    "name": "Pilleus Libertatis (Hat Pass for a Day)",
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554064109-Inventory%20Item%20(9).png?alt=media&token=24dc2242-4a6e-4408-92ab-e30dc774b072",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "opt_usable": true,
    "desc": "In ancient Rome, a pilleus symbolized freedom! With this, you may wear your chosen headwear, just like a freedman, for an entire day.",
    "opt_preview": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true
  },
  "1772230537875-86781-LNymX-item": {
    "desc": "A torn piece of an ancient scroll, bearing elegantly inscribed Roman numerals. It's a testament to Roman ingenuity in mathematics and record-keeping.",
    "opt_usable": true,
    "opt_preview": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b",
    "ts": 1774792694642,
    "name": "Scroll Fragment",
    "id": "1772230537875-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "path": "9mnl229xj3wfi5m9zu",
    "opt_visible": true,
    "type": "item",
    "opt_limitInd": 1,
    "ts_created": 1772230537875,
    "ts_uploaded": 1772230537875,
    "opt_itemType": "collectible",
    "status": "active",
    "opt_cat": "Relics of the Empire"
  },
  "1772230537876-86781-LNymX-item": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537876-86781-LNymX-item",
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554085909-Inventory%20Item%20(10).png?alt=media&token=4a453739-b714-480d-985a-84794eab7cdd",
    "ts": 1774793333472,
    "name": "Sella Curulis (Special Chair for a Day)",
    "desc": "Claim the prestigious Sella Curulis for a day! This ornate seat was reserved for the highest Roman magistrates, signifying your temporary elevation to a position of honor.",
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_market": true,
    "opt_itemType": "inventory",
    "path": "tm5yh27gmuxldw0vky",
    "opt_visible": true,
    "type": "item",
    "opt_limitInd": 2,
    "ts_created": 1772230537876,
    "ts_uploaded": 1772230537876
  },
  "1772230537877-86781-LNymX-item": {
    "opt_itemType": "inventory",
    "path": "sgqq9h4dqmuxs2kdj8",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537877,
    "ts_created": 1772230537877,
    "opt_limitInd": 2,
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554116045-Inventory%20Item%20(11).png?alt=media&token=ba00b05b-5742-4579-84d0-25894c91a127",
    "opt_marketPrice": 100,
    "name": "Tabula Rasa (Homework Pass)",
    "ts": 1774793344156,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": false,
    "desc": "A pristine wax tablet, signifying a day free from the usual scholastic duties. No scrolls or papyrus to fill, citizen!",
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537877-86781-LNymX-item"
  },
  "1772230537878-86781-LNymX-item": {
    "ts_uploaded": 1772230537878,
    "ts_created": 1772230537878,
    "opt_limitInd": 2,
    "type": "item",
    "path": "54sq0nyvvuebrw4s9p",
    "opt_visible": true,
    "opt_itemType": "inventory",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_usable": true,
    "desc": "A highly valued commodity! This allows you a period of truly unbound time to pursue your own interests, just as a Roman citizen might enjoy personal leisure in their villa.",
    "opt_preview": false,
    "name": "Tempus Solutum (Free Time)",
    "ts": 1774793356580,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564941724-Inventory%20Item%20(12).png?alt=media&token=19096192-f911-49e3-8280-c8c0e400e266",
    "opt_marketPrice": 100,
    "id": "1772230537878-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772230537879-86781-LNymX-item": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537879-86781-LNymX-item",
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564972120-Inventory%20Item%20(13).png?alt=media&token=d82cc334-3bc9-49a7-a89d-13608f1b7dba",
    "name": "Abacus of the Architect",
    "ts": 1774793318209,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_usable": true,
    "desc": "Use an in-class Calculator for one full day",
    "opt_preview": true,
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_market": true,
    "opt_itemType": "inventory",
    "type": "item",
    "path": "zv3k5vokbz365u7izg",
    "opt_visible": true,
    "ts_uploaded": 1772230537879,
    "ts_created": 1772230537879
  },
  "1772230537880-86781-LNymX-item": {
    "opt_visible": true,
    "path": "w16qizffa7qgin0m6d",
    "type": "item",
    "ts_uploaded": 1772230537880,
    "opt_limitInd": 1,
    "ts_created": 1772230537880,
    "opt_itemType": "inventory",
    "opt_cat": "Access Granted",
    "status": "active",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "desc": "The Golden Book: A legendary, illuminated manuscript containing the \"secrets of rhetoric\" and advanced literary patterns. This item grants you access to the Senator's Challenges",
    "opt_preview": true,
    "opt_usable": true,
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306786854-Access%20Item%20(2).png?alt=media&token=d6bcc89e-6c1d-4a69-b47b-d57202dd2d1b",
    "name": "The Codex Aureus",
    "ts": 1774792117506,
    "id": "1772230537880-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772230537881-86781-LNymX-item": {
    "status": "active",
    "opt_cat": "The Imperial Indulgences",
    "opt_market": true,
    "opt_itemType": "inventory",
    "path": "0pn26i4hthe1iyh8r6",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537881,
    "opt_limitInd": 2,
    "ts_created": 1772230537881,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537881-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303141509-Inventory%20Item%20(2).png?alt=media&token=4f138801-ddcf-4f5e-bd16-824a301c8b03",
    "opt_marketPrice": 200,
    "name": "The Aegis of Aeneas",
    "ts": 1774792969473,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "24-Hour Grace: Grants a one-day extension on any minor assignment without penalty.",
    "opt_usable": true,
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772230537882-86781-LNymX-item": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "opt_preview": true,
    "desc": "The Do-Over: Allows a student to resubmit one assignment for a regrade (within one week of return).",
    "opt_usable": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "ts": 1774792993109,
    "name": "The Janus Key",
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303244750-Inventory%20Item%20(3).png?alt=media&token=8755aa8b-307b-4316-b462-ce838cacdaf5",
    "id": "1772230537882-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_limitInd": 2,
    "ts_created": 1772230537882,
    "ts_uploaded": 1772230537882,
    "type": "item",
    "opt_visible": true,
    "path": "p00nuqc5beu75fkllr",
    "opt_itemType": "inventory",
    "opt_market": true,
    "opt_cat": "The Imperial Indulgences",
    "status": "active"
  },
  "1772230537883-86781-LNymX-item": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537883-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772300758021-Inventory%20Item%20(1).png?alt=media&token=5c8323e0-6e0c-4333-9aa5-05066cd46138",
    "opt_marketPrice": 200,
    "name": "Apollo’s Laurel",
    "ts": 1774792978326,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "The Insight Bonus: Grants a +5% \"inspiration boost\" to any single quiz or test score.",
    "opt_usable": true,
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_market": true,
    "opt_itemType": "inventory",
    "opt_visible": true,
    "path": "2dluhmmhngk57wts6j",
    "type": "item",
    "ts_uploaded": 1772230537883,
    "ts_created": 1772230537883,
    "opt_limitInd": 2
  },
  "1772230537884-86781-LNymX-item": {
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_market": true,
    "opt_itemType": "inventory",
    "type": "item",
    "opt_visible": true,
    "path": "6s54x4tkomnmbwwqij",
    "opt_limitInd": 2,
    "ts_created": 1772230537884,
    "ts_uploaded": 1772230537884,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537884-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307861026-Inventory%20Item%20(4).png?alt=media&token=990024c3-53a3-4d76-8eb0-12456828de8e",
    "opt_marketPrice": 200,
    "ts": 1774793017047,
    "name": "The Lyre of Orpheus",
    "desc": "Sonic Sanctuary: Permits the user to listen to music during independent writing time for one full week.",
    "opt_preview": true,
    "opt_usable": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040
  },
  "1772230537885-86781-LNymX-item": {
    "opt_itemType": "inventory",
    "path": "8ovknxepyw3oaflub1",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537885,
    "ts_created": 1772230537885,
    "opt_limitInd": 2,
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
    "opt_marketPrice": 200,
    "name": "The Praetorian Pardon",
    "ts": 1774793031022,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "The Skip: Allows the student to \"opt-out\" of one low-stakes homework assignment (no XP earned, but no grade penalty).",
    "opt_usable": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537885-86781-LNymX-item"
  },
  "1772230537886-86781-LNymX-item": {
    "opt_itemType": "inventory",
    "opt_visible": true,
    "path": "4sba9yfjhufcbcmreq",
    "type": "item",
    "ts_uploaded": 1772230537886,
    "opt_limitInd": 2,
    "ts_created": 1772230537886,
    "status": "active",
    "opt_cat": "The Imperial Indulgences",
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772308091269-Inventory%20Item%20(6).png?alt=media&token=446851bc-81a0-4b02-9e75-d0fa1c7593ff",
    "opt_marketPrice": 50,
    "name": "The Standard of the First Legion",
    "ts": 1774793041224,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Legionary Support: Allows the student to ask the teacher for one \"high-level hint\" during an in-class essay or exam.",
    "opt_preview": true,
    "opt_usable": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537886-86781-LNymX-item"
  },
  "1772230537887-86781-LNymX-item": {
    "opt_dateOpen": 1772230462040,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "Used by officials to sign documents. This item gives you access to a new set of Challenges",
    "opt_usable": true,
    "name": "The Signet Ring (Seal of Authority)",
    "ts": 1774792166837,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306152881-Access%20Item%20(1).png?alt=media&token=9572a5ae-5f50-4478-9e76-0e5f361ddeea",
    "id": "1772230537887-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_uploaded": 1772230537887,
    "ts_created": 1772230537887,
    "opt_limitInd": 1,
    "type": "item",
    "opt_visible": true,
    "path": "nqo7uvbhbs7li4m7ig",
    "opt_itemType": "inventory",
    "status": "active",
    "opt_cat": "Access Granted"
  },
  "1772230537888-86781-LNymX-item": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "desc": "This divine weapon, forged by the Cyclopes, represents the supreme authority of the King of the Gods over the heavens and the earth. It is a symbol of both destructive power and the celestial light used to maintain order in the universe.",
    "opt_preview": true,
    "opt_usable": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "ts": 1774792626478,
    "name": "Jupiter's Thunderbolt",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
    "id": "1772230537888-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_limitInd": 1,
    "ts_created": 1772230537888,
    "ts_uploaded": 1772230537888,
    "path": "ib5k3f1bvm1mgpt6vv",
    "type": "item",
    "opt_visible": true,
    "opt_itemType": "collectible",
    "status": "active",
    "opt_cat": "The Pantheon's Favor"
  },
  "1772230537889-86781-LNymX-item": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "This three-pronged spear was the primary tool of the god of the sea, used to shatter rocks, create new bodies of water, and stir up violent storms. It symbolizes the god's absolute dominion over the oceans and his ability to cause earthquakes with a single strike.",
    "opt_usable": true,
    "name": "Neptune's Trident",
    "ts": 1774792681494,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
    "opt_marketPrice": 200,
    "id": "1772230537889-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_uploaded": 1772230537889,
    "opt_limitInd": 1,
    "ts_created": 1772230537889,
    "opt_visible": true,
    "type": "item",
    "path": "ilh8xo3md2nfsx7hcr",
    "opt_itemType": "collectible",
    "opt_market": true,
    "opt_cat": "The Pantheon's Favor",
    "status": "active"
  },
  "1772230537890-86781-LNymX-item": {
    "ts_uploaded": 1772230537890,
    "ts_created": 1772230537890,
    "opt_limitInd": 1,
    "type": "item",
    "path": "adcikmh7iw7c4eir23",
    "opt_visible": true,
    "opt_itemType": "collectible",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Pantheon's Favor",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "As a creature that can see in the dark, the owl represents the goddess's ability to perceive truths that others cannot, making it the ultimate symbol of wisdom and strategic intelligence. It serves as a reminder that true knowledge requires both vigilance and a clear-eyed perspective on the world.",
    "opt_preview": true,
    "opt_usable": true,
    "name": "Minerva's Owl",
    "ts": 1774792657892,
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
    "id": "1772230537890-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772230537891-86781-LNymX-item": {
    "opt_itemType": "collectible",
    "path": "8lj8mddumue47fm72d",
    "opt_visible": true,
    "type": "item",
    "ts_uploaded": 1772230537891,
    "opt_limitInd": 1,
    "ts_created": 1772230537891,
    "status": "active",
    "opt_cat": "The Pantheon's Favor",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
    "name": "Mercury's Winged Sandal",
    "ts": 1774792645379,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": true,
    "desc": "Known as the talaria, these magical golden sandals were crafted by Vulcan to allow the messenger god to fly at incredible speeds. They represent the swiftness of thought and the ability to cross any boundary, whether between lands or between the mortal and divine realms.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772230462040,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772230537891-86781-LNymX-item"
  },
  "1772233183963-86781-LNymX-collection": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772233182186-Collectible.jpg?alt=media&token=1d3d9f0b-182c-424c-83af-957fc7dd64b3",
    "name": "The Pantheons Favor",
    "ts": 1772590464005,
    "opt_available": true,
    "opt_earnedCurrency": 300,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Collect all of the gods' artifacts to gain access to a new set of challenges!",
    "opt_preview": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_itemList": [
      "1772230537888-86781-LNymX-item",
      "1772230537891-86781-LNymX-item",
      "1772230537890-86781-LNymX-item",
      "1772230537889-86781-LNymX-item"
    ],
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772233183963-86781-LNymX-collection",
    "path": "lvny1o6jvvvp0_w-3o",
    "type": "collection",
    "opt_visible": true,
    "opt_earnedItems": {
      "1772230537887-86781-LNymX-item": {
        "quantity": 1,
        "id": "1772230537887-86781-LNymX-item"
      }
    },
    "ts_created": 1772233189515,
    "status": "active",
    "public": true
  },
  "1772563864434-86781-LNymX-item": {
    "ts_created": 1772563865650,
    "type": "item",
    "opt_visible": true,
    "path": "3i9b_9edz20rizm6k-",
    "opt_itemType": "realworld",
    "opt_market": true,
    "public": true,
    "status": "active",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "Purchasing this item will get you one choice from the snack selection.",
    "name": "One Snack Item",
    "ts": 1772564142589,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564140348-Real%20World%20Item%20Template%20(1).png?alt=media&token=4bf0c1e3-fa04-4e0f-a0de-f3a64555b99d",
    "opt_marketPrice": 300,
    "id": "1772563864434-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game"
  },
  "1772564322752-86781-LNymX-item": {
    "id": "1772564322752-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "Purchasing this item gets you access to one soda.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564321316-Real%20World%20Item%20Template%20(2).png?alt=media&token=937eb80f-707a-47cc-9463-7fa80236ebf4",
    "opt_marketPrice": 300,
    "name": "One Soda",
    "ts": 1772564323970,
    "status": "active",
    "opt_market": true,
    "public": true,
    "opt_visible": true,
    "path": "3989__og6ev6a66jjp",
    "type": "item",
    "ts_created": 1772564323970,
    "opt_itemType": "realworld"
  },
  "1772566406210-86781-LNymX-item": {
    "opt_itemType": "contribution",
    "opt_visible": true,
    "path": "15m14_s1f15dwgh3a6",
    "type": "item",
    "ts_created": 1772566407437,
    "status": "active",
    "public": true,
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566404290-Contribution%20Item%20Template%20(2).png?alt=media&token=595bf220-ca57-43bd-aa05-fd6a26a0f993",
    "ts": 1772566407437,
    "name": "Forum Collection: Pizza Party",
    "opt_preview": true,
    "desc": "Contribute 3,000 coins to give the entire class a pizza party!",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_contributionGoal": 3000,
    "id": "1772566406210-86781-LNymX-item"
  },
  "1772566827182-86781-LNymX-item": {
    "id": "1772566827182-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "Purchasing this item will get you one mechanical pencil.",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566825895-Real%20World%20Item%20Template%20(5).png?alt=media&token=66705a95-f162-4a01-a64e-bfe8fbfac394",
    "name": "One Mechanical Pencil",
    "ts": 1772566828397,
    "status": "active",
    "opt_market": true,
    "public": true,
    "opt_visible": true,
    "type": "item",
    "path": "2873x4dc5nbn4xkayw",
    "ts_created": 1772566828397,
    "opt_itemType": "realworld"
  },
  "1772567715658-86781-LNymX-badge": {
    "name": "Eloquentia (The Gift of Eloquence)",
    "ts": 1772568474544,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772567714277-Badge%20Template.png?alt=media&token=406a8e5e-f7a9-485d-98dc-6fa77d56ed44",
    "opt_purposeGroup": false,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrency": 100,
    "opt_available": true,
    "desc": "Awarded for making three meaningful, unprompted contributions to a Socratic Seminar or class discussion.",
    "opt_preview": true,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772567715658-86781-LNymX-badge",
    "ts_created": 1772567716915,
    "path": "q5_sdclod5z5plcp4z",
    "type": "badge",
    "opt_visible": true,
    "status": "active"
  },
  "1772568083563-86781-LNymX-badge": {
    "status": "active",
    "ts_created": 1772568084808,
    "path": "tsknlj8l-hsdpqtoz0",
    "type": "badge",
    "opt_visible": true,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568083563-86781-LNymX-badge",
    "ts": 1772568445461,
    "name": "Nocturnal Scholar (Reading for Pleasure)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568081970-Badge%20Template%20(1).png?alt=media&token=e7a317e3-c382-4b65-a75c-e67861edcc7c",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_purposeGroup": false,
    "opt_preview": true,
    "desc": "Awarded for \"reading for pleasure\" outside of school hours for seven consecutive days (verified by a reading log or parent).",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_earnedCurrency": 100
  },
  "1772568315017-86781-LNymX-badge": {
    "ts_created": 1772568316285,
    "type": "badge",
    "path": "fg3w76yqisj_py-xkm",
    "opt_visible": true,
    "status": "active",
    "name": "The Archivists Triumph (Achievement in Organization)",
    "ts": 1772568429485,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568313294-Badge%20Template%20(2).png?alt=media&token=a924295e-a656-48ca-b072-e56911735a90",
    "opt_purposeGroup": false,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrency": 100,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Awarded for maintaining a perfectly organized digital folder or physical binder throughout the quarter.",
    "opt_preview": true,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568315017-86781-LNymX-badge"
  },
  "1772568608019-86781-LNymX-badge": {
    "status": "active",
    "path": "4xlkt5whenhhkqys57",
    "type": "badge",
    "opt_visible": true,
    "ts_created": 1772568609248,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568608019-86781-LNymX-badge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568606661-Badge%20Template%20(3).png?alt=media&token=6c68e9db-42ce-4765-b7a2-7973ab8a61a3",
    "name": "Grammaticus Maximus (Achievement in Writing)",
    "ts": 1772568609248,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrency": 100,
    "opt_available": true,
    "desc": "Awarded for submitting a \"Flawless Scroll\", a final draft with zero errors in grammar, punctuation, or spelling.",
    "opt_preview": true,
    "opt_purposeGroup": false,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  },
  "1772568758645-86781-LNymX-badge": {
    "status": "active",
    "ts_created": 1772568759853,
    "opt_visible": true,
    "type": "badge",
    "path": "ojrun84qobzszp0ccc",
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772568758645-86781-LNymX-badge",
    "name": "Rhetorics Aegis (Arguments with Aplomb)",
    "ts": 1772568759853,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568757154-Badge%20Template%20(5).png?alt=media&token=266b8e09-33c4-448f-83d7-a25825923100",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_purposeGroup": false,
    "opt_available": true,
    "opt_earnedCurrency": 100,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "desc": "Awarded for successfully identifying and explaining Ethos, Pathos, and Logos in a real-world advertisement or speech."
  },
  "1772568921625-86781-LNymX-badge": {
    "id": "1772568921625-86781-LNymX-badge",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_preview": true,
    "desc": "Awarded for demonstrating growth in typing speed or meeting a specific Words-Per-Minute (WPM) milestone.",
    "opt_available": true,
    "opt_earnedCurrency": 100,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_purposeGroup": false,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568919961-Badge%20Template%20(6).png?alt=media&token=35c46dc2-e9e3-4a5c-8046-0de0452accf4",
    "ts": 1772568922858,
    "name": "Scribe Velocity (Speed of Script)",
    "status": "active",
    "opt_visible": true,
    "type": "badge",
    "path": "7dl_hbob5ezi7wp1ry",
    "ts_created": 1772568922858
  },
  "1772569136690-86781-LNymX-badge": {
    "id": "1772569136690-86781-LNymX-badge",
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_purposeGroup": false,
    "opt_preview": true,
    "desc": "Awarded for \"perfect logistics\" submitting every assignment on time for a full month.",
    "opt_available": true,
    "opt_earnedCurrency": 100,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772569137960,
    "name": "Cursus Honorum (The Path of Honor)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569134967-Badge%20Template%20(7).png?alt=media&token=b8857abb-4adb-4cc6-8173-271778bb98ff",
    "status": "active",
    "ts_created": 1772569137960,
    "opt_visible": true,
    "path": "2msg0hfem8sa39qin8",
    "type": "badge"
  },
  "1772569257452-86781-LNymX-badge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569255869-Badge%20Template%20(8).png?alt=media&token=5680f20d-1c2c-4698-8e09-ecf0199074e8",
    "ts": 1772569258766,
    "name": "Lexicon Legatus (Vocabulary Envoy)",
    "opt_preview": true,
    "desc": "Awarded for correctly using three \"challenge words\" in a single piece of formal writing.",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrency": 100,
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_purposeGroup": false,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772569257452-86781-LNymX-badge",
    "type": "badge",
    "path": "wabxktmejd4m_j0kwj",
    "opt_visible": true,
    "ts_created": 1772569258766,
    "status": "active"
  },
  "1772569770551-86781-LNymX-challenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "ts": 1774625730762,
    "name": "The Forum Oration",
    "opt_preview": true,
    "desc": "<p>Record a 60-second video or perform a dramatic reading of a famous monologue or poem with appropriate \"Roman\" gravitas (tone, pacing, and emotion). Include the link to the video in the input box below.</p>",
    "opt_earnedCurrency": 300,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772569770551,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedPoints": 300,
    "opt_allowFileUpload": true,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_inputType": "shortAnswer",
    "id": "1772569770551-86781-LNymX-challenge",
    "opt_visible": true,
    "type": "challenge",
    "path": "60d4y80ktqectdx0xc",
    "ts_created": 1772569771842,
    "opt_displayRewards": true,
    "status": "active",
    "opt_cat": "Citizen's Tasks",
    "public": true
  },
  "1772569834612-86781-LNymX-challenge": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772569834612,
    "opt_earnedCurrency": 150,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "<p>Choose a character from your current book. Write a three-sentence \"prophecy\" predicting their fate, using specific evidence from the text to justify your vision. </p>",
    "opt_preview": true,
    "name": "The Sibylline Prophecy",
    "ts": 1774625746647,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "id": "1772569834612-86781-LNymX-challenge",
    "opt_inputType": "paragraph",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 150,
    "opt_displayRewards": true,
    "ts_created": 1772569836157,
    "path": "4zbqmstr9c9jjc24ux",
    "type": "challenge",
    "opt_visible": true,
    "public": true,
    "status": "active",
    "opt_cat": "Citizen's Tasks"
  },
  "1772569886040-86781-LNymX-challenge": {
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 150,
    "opt_allowFileUpload": false,
    "id": "1772569886040-86781-LNymX-challenge",
    "opt_inputType": "paragraph",
    "name": "Veni, Vidi, Vici",
    "ts": 1774625766547,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772569886040,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_earnedCurrency": 150,
    "opt_preview": true,
    "desc": "<p>Read a high-quality long-form article or short story that was not assigned in class. Submit a three-sentence summary and one \"connection\" to our current unit.</p>",
    "public": true,
    "opt_cat": "Citizen's Tasks",
    "status": "active",
    "opt_displayRewards": true,
    "ts_created": 1772569887204,
    "type": "challenge",
    "path": "29bwi-ah-6h4cpdhvk",
    "opt_visible": true
  },
  "1772571725728-86781-LNymX-challenge": {
    "path": "p3qy54745ez9wy2y4q",
    "type": "challenge",
    "opt_visible": true,
    "opt_prereqItems": [
      "1772230537880-86781-LNymX-item"
    ],
    "opt_displayRewards": true,
    "ts_created": 1772571727071,
    "opt_cat": "Codex Aureus",
    "opt_prereq": true,
    "status": "active",
    "public": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571724680-appian.png?alt=media&token=61febc9d-17f3-462d-b605-d38328bd3d5b",
    "name": "The Appian Way",
    "ts": 1774625418695,
    "opt_earnedCurrency": 200,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "<p>Find five English words in your current reading that have Latin roots. List the word, the root, and how the meaning \"traveled\" from Ancient Rome to modern English.</p>",
    "opt_dateOpen": 1772571725728,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedPoints": 200,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_inputType": "shortAnswer",
    "id": "1772571725728-86781-LNymX-challenge"
  },
  "1772571789776-86781-LNymX-challenge": {
    "public": true,
    "opt_prereq": true,
    "ts_created": 1772571791095,
    "opt_displayRewards": true,
    "path": "dfh85yv_3oew-6d2oj",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 300,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "name": "Amphitheater Critique",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571788594-amphitheater.png?alt=media&token=6d415076-c1b0-426a-adc3-380ed60f1b6e",
    "opt_cat": "Codex Aureus",
    "status": "active",
    "opt_prereqItems": [
      "1772230537880-86781-LNymX-item"
    ],
    "opt_visible": true,
    "type": "challenge",
    "id": "1772571789776-86781-LNymX-challenge",
    "opt_inputType": "shortAnswer",
    "opt_allowFileUpload": false,
    "opt_dateOpen": 1772571789776,
    "desc": "<p>Write a \"Review of the Games\" for any film or play adaptation of a book. You must judge it on its faithfulness to the original \"script\" and its entertainment value.</p>",
    "opt_earnedCurrency": 300,
    "ts": 1774625435255
  },
  "1772571898963-86781-LNymX-challenge": {
    "opt_prereq": true,
    "status": "active",
    "opt_cat": "Codex Aureus",
    "public": true,
    "path": "iyxgdj9yb4he-5t60z",
    "type": "challenge",
    "opt_visible": true,
    "opt_prereqItems": [
      "1772230537880-86781-LNymX-item"
    ],
    "opt_displayRewards": true,
    "ts_created": 1772571900294,
    "opt_inputType": "shortAnswer",
    "id": "1772571898963-86781-LNymX-challenge",
    "opt_earnedPoints": 400,
    "gameId": "1772165586781-LNymXRI-game",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_earnedCurrency": 400,
    "desc": "<p>Take a modern scene (from a movie, show, or book) and rewrite the dialogue in an \"Epic\" or \"Formal\" style as if it were a classical Roman play.</p>",
    "opt_preview": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772571898963,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571897664-scroll.png?alt=media&token=654bf7ec-4a07-4d74-95af-4519c85f3b38",
    "name": "Scriptorium Scroll",
    "ts": 1774625452310
  },
  "1772572068570-86781-LNymX-challenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572067641-oracle2.png?alt=media&token=0723ea98-34df-4f78-8bd2-00b53f9b61b7",
    "name": "The Oracle's Verse",
    "ts": 1774625473904,
    "opt_earnedCurrency": 200,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "<p>Write a 10-line poem or prophecy about a current event or a school-related \"omen\" using three specific literary devices (e.g., alliteration, personification, and hyperbole).</p>",
    "opt_preview": true,
    "opt_dateOpen": 1772572068570,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedPoints": 200,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_inputType": "shortAnswer",
    "id": "1772572068570-86781-LNymX-challenge",
    "type": "challenge",
    "path": "atjnzei887cja7sqz5",
    "opt_visible": true,
    "opt_prereqItems": [
      "1772230537887-86781-LNymX-item"
    ],
    "opt_displayRewards": true,
    "ts_created": 1772572069891,
    "opt_cat": "Signet Ring",
    "opt_prereq": true,
    "status": "active",
    "public": true
  },
  "1772572118651-86781-LNymX-challenge": {
    "id": "1772572118651-86781-LNymX-challenge",
    "opt_inputType": "shortAnswer",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 300,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_dateOpen": 1772572118651,
    "desc": "<p>Design a physical or digital \"Map of a Mind.\" Choose a character from any book and map out their internal landscape (fears as mountains, goals as rivers, etc.).</p>",
    "opt_preview": true,
    "opt_earnedCurrency": 300,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "ts": 1774625613920,
    "name": "The Architect's Blueprint",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "public": true,
    "opt_prereq": true,
    "opt_cat": "Signet Ring",
    "status": "active",
    "ts_created": 1772572119848,
    "opt_prereqItems": [
      "1772230537887-86781-LNymX-item"
    ],
    "path": "q8uk_4hwijmpaw2ef4",
    "opt_visible": true,
    "type": "challenge"
  },
  "1772572157879-86781-LNymX-challenge": {
    "ts_created": 1772572159170,
    "opt_visible": true,
    "path": "0mtodi8qtrffa3mjfy",
    "type": "challenge",
    "opt_prereqItems": [
      "1772230537887-86781-LNymX-item"
    ],
    "public": true,
    "status": "active",
    "opt_prereq": true,
    "opt_cat": "Signet Ring",
    "opt_dateOpen": 1772572157879,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_earnedCurrency": 300,
    "desc": "<p>Create a 5-song playlist for a fictional character’s journey. Students must write a one-sentence justification for why each song fits that character's \"vibe.\"</p>",
    "opt_preview": true,
    "name": "The Muse's Soundtrack",
    "ts": 1774625569845,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572156886-music.png?alt=media&token=e2354199-92c6-4615-923a-92622ba900c3",
    "id": "1772572157879-86781-LNymX-challenge",
    "opt_inputType": "paragraph",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 300
  },
  "1772572212961-86781-LNymX-challenge": {
    "opt_visible": true,
    "type": "challenge",
    "opt_prereqItems": [
      "1772230537887-86781-LNymX-item"
    ],
    "opt_cat": "Signet Ring",
    "status": "active",
    "opt_dateOpen": 1772572212961,
    "opt_earnedCurrency": 300,
    "desc": "<p>Create an \"Illuminated Manuscript\" page for a single quote from a book you've read. The artwork surrounding the quote must symbolize the quote’s deeper meaning.</p>",
    "ts": 1774625604496,
    "id": "1772572212961-86781-LNymX-challenge",
    "opt_inputType": "shortAnswer",
    "opt_allowFileUpload": true,
    "opt_displayRewards": true,
    "ts_created": 1772572214154,
    "path": "0q6vxep5_p35ohp2x8",
    "public": true,
    "opt_prereq": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_preview": true,
    "name": "The Scribe's Illuminations",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572211824-sculptor.png?alt=media&token=e59179d5-0688-409f-8e17-1d918b7df3a6",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedPoints": 300
  },
  "1772590433659-86781-LNymX-collection": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_itemList": [
      "1772230537866-86781-LNymX-item",
      "1772230537868-86781-LNymX-item",
      "1772230537870-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "opt_available": true,
    "opt_earnedCurrency": 300,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Collect all of the Relics of the Empire to gain access to the next level of Challenges. ",
    "opt_preview": true,
    "name": "Relics of the Empire",
    "ts": 1772590438600,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590432691-Collection%20Template.png?alt=media&token=730a0a9f-93f2-42e7-9ff3-6936dee5992b",
    "id": "1772590433659-86781-LNymX-collection",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_created": 1772590438600,
    "opt_visible": true,
    "type": "collection",
    "path": "zt754wr-1mz0xozfu7",
    "opt_earnedItems": {
      "1772230537880-86781-LNymX-item": {
        "quantity": 1,
        "id": "1772230537880-86781-LNymX-item"
      }
    },
    "public": true,
    "status": "active"
  },
  "1772590648474-86781-LNymX-level": {
    "id": "1772590648474-86781-LNymX-level",
    "gameId": "1772165586781-LNymXRI-game",
    "opt_pointMinimum": 0,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Every student begins here. You are learning the basics of the \"legion,\" gathering your tools, and understanding the laws of the classroom.",
    "opt_preview": true,
    "opt_earnedCurrency": 200,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772597812599,
    "name": "Tiro (The Recruit)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "public": true,
    "status": "active",
    "ts_created": 1772590650338,
    "path": "vnzyuvgp-ikz728wnq",
    "type": "level",
    "opt_visible": true
  },
  "1772590711756-86781-LNymX-level": {
    "status": "active",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "quantity": 1
      }
    },
    "public": true,
    "type": "level",
    "opt_visible": true,
    "path": "-rn4xz-orgd_dbndjt",
    "ts_created": 1772590713628,
    "id": "1772590711756-86781-LNymX-level",
    "opt_pointMinimum": 500,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrency": 200,
    "desc": "You have proven your basic literacy and are now a full member of the literary republic, entitled to participate in more complex quests.",
    "opt_preview": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597828647-civis.png?alt=media&token=faa1c836-1f43-4563-8d03-5c72b25fa8a5",
    "name": "Civis (The Citizen):",
    "ts": 1772597831490
  },
  "1772590997526-86781-LNymX-prizepack": {
    "gameId": "1772165586781-LNymXRI-game",
    "opt_prizes": [
      "1772230537866-86781-LNymX-item",
      "1772230537868-86781-LNymX-item",
      "1772230537888-86781-LNymX-item",
      "1772230537891-86781-LNymX-item",
      "1772230537890-86781-LNymX-item",
      "1772230537870-86781-LNymX-item",
      "1772230537889-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "id": "1772590997526-86781-LNymX-prizepack",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "opt_marketPrice": 500,
    "name": "The Tribute Chest",
    "ts": 1772590999403,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_itemCount": 3,
    "opt_available": true,
    "opt_preview": true,
    "desc": "A prize pack of all of the collectible items players can earn. Remember, some of the items are very rare!",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_prizeWeights": {
      "1772230537868-86781-LNymX-item": {
        "weight": 10,
        "id": "1772230537868-86781-LNymX-item"
      },
      "1772230537866-86781-LNymX-item": {
        "weight": 20,
        "id": "1772230537866-86781-LNymX-item"
      },
      "1772230537890-86781-LNymX-item": {
        "weight": 20,
        "id": "1772230537890-86781-LNymX-item"
      },
      "1772230537870-86781-LNymX-item": {
        "id": "1772230537870-86781-LNymX-item",
        "weight": 10
      },
      "1772230537891-86781-LNymX-item": {
        "weight": 20,
        "id": "1772230537891-86781-LNymX-item"
      },
      "1772230537889-86781-LNymX-item": {
        "weight": 5,
        "id": "1772230537889-86781-LNymX-item"
      },
      "1772230537888-86781-LNymX-item": {
        "weight": 20,
        "id": "1772230537888-86781-LNymX-item"
      },
      "1772230537875-86781-LNymX-item": {
        "id": "1772230537875-86781-LNymX-item",
        "weight": 5
      }
    },
    "status": "active",
    "opt_market": true,
    "opt_itemType": "prizepack",
    "opt_visible": true,
    "type": "item",
    "path": "g933gh8skhusoowurr",
    "ts_created": 1772590999403
  },
  "1772591111727-86781-LNymX-level": {
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "quantity": 1
      }
    },
    "status": "active",
    "public": true,
    "path": "39tlevyjbtc3jnqdpb",
    "type": "level",
    "opt_visible": true,
    "ts_created": 1772591113605,
    "id": "1772591111727-86781-LNymX-level",
    "opt_pointMinimum": 1500,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_preview": true,
    "desc": "You lead by example. Your writing is disciplined, and your analysis is a weapon. You have mastered the \"tactics\" of standard literature.",
    "opt_earnedCurrency": 300,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597842378-centurion.png?alt=media&token=10ec62e5-a09b-4f12-9938-c1e5dd259b90",
    "ts": 1772597845143,
    "name": "Centurion (The Leader):"
  },
  "1772591192992-86781-LNymX-level": {
    "id": "1772591192992-86781-LNymX-level",
    "opt_pointMinimum": 3500,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_preview": true,
    "desc": "You don't just follow the curriculum; you influence it. You offer deep insights during discussions and your rhetoric is respected by your peers.",
    "opt_earnedCurrency": 400,
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597857170-statesman.png?alt=media&token=acea89fb-3722-441c-872c-28dd52a0bcf2",
    "ts": 1772597860074,
    "name": "Senator (The Statesman):",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "quantity": 1
      }
    },
    "status": "active",
    "public": true,
    "opt_earnedItems": {
      "1772230537880-86781-LNymX-item": {
        "id": "1772230537880-86781-LNymX-item",
        "quantity": 1
      }
    },
    "type": "level",
    "opt_visible": true,
    "path": "syao-jbvgv0h6cp8ez",
    "ts_created": 1772591194869
  },
  "1772591247490-86781-LNymX-level": {
    "id": "1772591247490-86781-LNymX-level",
    "opt_pointMinimum": 7000,
    "gameId": "1772165586781-LNymXRI-game",
    "opt_earnedCurrency": 500,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "desc": "Reserved for those who have achieved total victory over the syllabus. You are a master of the craft, capable of complex synthesis and creative leadership.",
    "opt_preview": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597873344-commander.png?alt=media&token=7eb947b7-f394-4e9e-a030-ec4b92217ea1",
    "name": "Imperator (The Commander):",
    "ts": 1772597876063,
    "status": "active",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "quantity": 1
      }
    },
    "public": true,
    "path": "_blwczd6siq6p_8csw",
    "type": "level",
    "opt_visible": true,
    "ts_created": 1772591249244
  },
  "1772595348383-86781-LNymX-secretCode": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772595348383-86781-LNymX-secretCode",
    "ts": 1772595348383,
    "name": "PAPYRUS-893",
    "opt_earnedCurrencyMax": 50,
    "icon": "/images/icons/secret.png",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Hidden under a chair in the classroom",
    "opt_available": true,
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "code": "PAPYRUS-893",
    "ts_created": 1772595348383,
    "ts_uploaded": 1772595348383,
    "opt_earnedCurrencyMin": 50,
    "type": "secretCode",
    "opt_visible": true,
    "path": "7aqm7axliou6nvcikg"
  },
  "1772595348384-86781-LNymX-secretCode": {
    "id": "1772595348384-86781-LNymX-secretCode",
    "gameId": "1772165586781-LNymXRI-game",
    "desc": "Solution to a weekly puzzle",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrencyMax": 50,
    "icon": "/images/icons/secret.png",
    "ts": 1772595348384,
    "name": "STYLUS-632",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "opt_earnedCurrencyMin": 50,
    "type": "secretCode",
    "opt_visible": true,
    "path": "2btibnaovnmie3g9kf",
    "ts_created": 1772595348384,
    "ts_uploaded": 1772595348384,
    "code": "STYLUS-632"
  },
  "1772595348385-86781-LNymX-secretCode": {
    "id": "1772595348385-86781-LNymX-secretCode",
    "gameId": "1772165586781-LNymXRI-game",
    "desc": "Hidden in a book in the library",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrencyMax": 50,
    "icon": "/images/icons/secret.png",
    "ts": 1772595348385,
    "name": "CODEX-090",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "opt_earnedCurrencyMin": 50,
    "opt_visible": true,
    "path": "e754ok1n4b5egx718v",
    "type": "secretCode",
    "ts_created": 1772595348385,
    "ts_uploaded": 1772595348385,
    "code": "CODEX-090"
  },
  "1772595348386-86781-LNymX-secretCode": {
    "code": "EPICUS-284",
    "ts_created": 1772595348386,
    "ts_uploaded": 1772595348386,
    "opt_earnedCurrencyMin": 50,
    "type": "secretCode",
    "opt_visible": true,
    "path": "i5i7hiflasusj1n6n5",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "ts": 1772595348386,
    "name": "EPICUS-284",
    "icon": "/images/icons/secret.png",
    "opt_earnedCurrencyMax": 50,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "Hidden in the guidance office",
    "opt_available": true,
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772595348386-86781-LNymX-secretCode"
  },
  "1772595348387-86781-LNymX-secretCode": {
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "opt_earnedCurrencyMin": 50,
    "opt_visible": true,
    "path": "golyyzvq8bvw7b4ena",
    "type": "secretCode",
    "ts_created": 1772595348387,
    "ts_uploaded": 1772595348387,
    "code": "SATURAE-380",
    "id": "1772595348387-86781-LNymX-secretCode",
    "gameId": "1772165586781-LNymXRI-game",
    "desc": "Solution to a weekly puzzle",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedCurrencyMax": 50,
    "icon": "/images/icons/secret.png",
    "ts": 1772595348387,
    "name": "SATURAE-380"
  },
  "1772595348388-86781-LNymX-secretCode": {
    "gameId": "1772165586781-LNymXRI-game",
    "id": "1772595348388-86781-LNymX-secretCode",
    "opt_earnedCurrencyMax": 50,
    "icon": "/images/icons/secret.png",
    "ts": 1772595348388,
    "name": "RHETOR-258",
    "desc": "Hidden in the main office",
    "opt_available": true,
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_earnedPrizePacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "quantity": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "status": "active",
    "code": "RHETOR-258",
    "opt_earnedCurrencyMin": 50,
    "type": "secretCode",
    "opt_visible": true,
    "path": "k9qel9aidq5h2heryz",
    "ts_created": 1772595348388,
    "ts_uploaded": 1772595348388
  },
  "1772691604870-86781-LNymX-leaderboard": {
    "totals": true,
    "public": true,
    "status": "active",
    "data": "points",
    "ts_created": 1772691605228,
    "type": "leaderboard",
    "path": "700zu5e_4b9nrk22w7",
    "opt_visible": true,
    "nameDisplay": "display",
    "gameId": "1772165586781-LNymXRI-game",
    "count": 20,
    "id": "1772691604870-86781-LNymX-leaderboard",
    "name": "Team Points",
    "levels": false,
    "ts": 1772691605228,
    "icon": "/images/icons/leaderboard.png",
    "indOrTeams": "teams",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "desc": "This leaderboard displays Team members' combined point totals."
  },
  "1772691651374-86781-LNymX-leaderboard": {
    "public": true,
    "status": "active",
    "totals": true,
    "data": "points",
    "ts_created": 1772691651616,
    "nameDisplay": "display",
    "opt_visible": true,
    "type": "leaderboard",
    "path": "jeos30_-w7bpoj717m",
    "id": "1772691651374-86781-LNymX-leaderboard",
    "count": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "indOrTeams": "individuals",
    "desc": "This leaderboard displays the individual XP leaders.",
    "opt_available": true,
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "ts": 1772691855258,
    "name": "Individual XP Leaders",
    "icon": "/images/icons/leaderboard.png"
  },
  "1772691991174-86781-LNymX-leaderboard": {
    "public": true,
    "status": "active",
    "totals": true,
    "data": "currencyTotal",
    "ts_created": 1772691991537,
    "type": "leaderboard",
    "path": "y7mhyglpykkp23os65",
    "opt_visible": true,
    "nameDisplay": "display",
    "id": "1772691991174-86781-LNymX-leaderboard",
    "count": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "indOrTeams": "individuals",
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "desc": "This leaderboard displays the total currency earners.",
    "name": "Individual Currency Leaders",
    "ts": 1772691991537,
    "icon": "/images/icons/leaderboard.png"
  },
  "1773106682903-86781-LNymX-item": {
    "appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "lastEditedBy": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "opt_available": true,
    "opt_preview": true,
    "desc": "The Winner of the Pax Romana Lottery gets to choose the music playlist and ambient lighting for work times during class for a week.",
    "name": "Pax Romana Lottery",
    "ts": 1773106687913,
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1773106680758-Lottery%20(1).png?alt=media&token=2f45d15d-ec16-4e26-a83e-3738bda533f1",
    "id": "1773106682903-86781-LNymX-item",
    "gameId": "1772165586781-LNymXRI-game",
    "ts_created": 1773106687913,
    "opt_visible": true,
    "type": "item",
    "path": "nd0fh54v99z7vxjibf",
    "opt_itemType": "lottery",
    "opt_market": true,
    "public": true,
    "status": "active"
  }
}

export const completeGameElementData = {
  "1772230537887-86781-LNymX-item": {
    "id": "1772230537887-86781-LNymX-item",
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": true,
    "opt_marketPrice": null,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306152881-Access%20Item%20(1).png?alt=media&token=9572a5ae-5f50-4478-9e76-0e5f361ddeea",
    "name": "The Signet Ring (Seal of Authority)",
    "ts": 1774792166837,
    "opt_cat": "Access Granted",
    "status": "active",
    "opt_market": false,
    "path": "nqo7uvbhbs7li4m7ig",
    "type": "item",
    "opt_visible": true,
    "opt_itemType": "inventory"
  },
  "1772568315017-86781-LNymX-badge": {
    "ts": 1772568429485,
    "name": "The Archivists Triumph (Achievement in Organization)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568313294-Badge%20Template%20(2).png?alt=media&token=a924295e-a656-48ca-b072-e56911735a90",
    "opt_preview": true,
    "type": "badge",
    "path": "fg3w76yqisj_py-xkm",
    "opt_available": true,
    "opt_visible": true,
    "id": "1772568315017-86781-LNymX-badge",
    "opt_cat": null,
    "status": "active"
  },
  "1772230537889-86781-LNymX-item": {
    "opt_cat": "The Pantheon's Favor",
    "status": "active",
    "opt_market": true,
    "path": "ilh8xo3md2nfsx7hcr",
    "opt_visible": true,
    "type": "item",
    "opt_itemType": "collectible",
    "id": "1772230537889-86781-LNymX-item",
    "opt_available": true,
    "opt_preview": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295527734-Inventory%20Item.png?alt=media&token=84f0a9dc-39d9-492c-9bdf-4309442405ad",
    "opt_marketPrice": 200,
    "name": "Neptune's Trident",
    "ts": 1774792681494
  },
  "1772566406210-86781-LNymX-item": {
    "opt_itemType": "contribution",
    "type": "item",
    "path": "15m14_s1f15dwgh3a6",
    "opt_visible": true,
    "status": "active",
    "opt_cat": null,
    "opt_market": true,
    "opt_marketPrice": null,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566404290-Contribution%20Item%20Template%20(2).png?alt=media&token=595bf220-ca57-43bd-aa05-fd6a26a0f993",
    "ts": 1772566407437,
    "name": "Forum Collection: Pizza Party",
    "opt_preview": true,
    "opt_available": true,
    "id": "1772566406210-86781-LNymX-item"
  },
  "1772591247490-86781-LNymX-level": {
    "id": "1772591247490-86781-LNymX-level",
    "opt_cat": null,
    "status": "active",
    "opt_pointMinimum": 7000,
    "type": "level",
    "opt_available": true,
    "opt_visible": true,
    "path": "_blwczd6siq6p_8csw",
    "opt_preview": true,
    "name": "Imperator (The Commander):",
    "ts": 1772597876063,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597873344-commander.png?alt=media&token=7eb947b7-f394-4e9e-a030-ec4b92217ea1"
  },
  "1772230537881-86781-LNymX-item": {
    "type": "item",
    "path": "0pn26i4hthe1iyh8r6",
    "opt_visible": true,
    "opt_itemType": "inventory",
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_market": true,
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303141509-Inventory%20Item%20(2).png?alt=media&token=4f138801-ddcf-4f5e-bd16-824a301c8b03",
    "opt_marketPrice": 200,
    "ts": 1774792969473,
    "name": "The Aegis of Aeneas",
    "id": "1772230537881-86781-LNymX-item"
  },
  "1772230537888-86781-LNymX-item": {
    "opt_itemType": "collectible",
    "path": "ib5k3f1bvm1mgpt6vv",
    "opt_visible": true,
    "type": "item",
    "opt_cat": "The Pantheon's Favor",
    "status": "active",
    "opt_market": false,
    "opt_marketPrice": null,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295258265-Inventory%20Item%20(1).png?alt=media&token=709f0c26-309e-43dd-8ba0-89fd2e3eac74",
    "ts": 1774792626478,
    "name": "Jupiter's Thunderbolt",
    "opt_preview": true,
    "opt_available": true,
    "id": "1772230537888-86781-LNymX-item"
  },
  "1772572118651-86781-LNymX-challenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572117328-journey.png?alt=media&token=7cad1335-9e37-484d-ba59-8f8f6bb99a9d",
    "name": "The Architect's Blueprint",
    "ts": 1774625613920,
    "type": "challenge",
    "opt_available": true,
    "path": "q8uk_4hwijmpaw2ef4",
    "opt_visible": true,
    "opt_preview": true,
    "status": "active",
    "opt_cat": "Signet Ring",
    "id": "1772572118651-86781-LNymX-challenge"
  },
  "1772572212961-86781-LNymX-challenge": {
    "name": "The Scribe's Illuminations",
    "ts": 1774625604496,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572211824-sculptor.png?alt=media&token=e59179d5-0688-409f-8e17-1d918b7df3a6",
    "opt_visible": true,
    "path": "0q6vxep5_p35ohp2x8",
    "opt_available": true,
    "type": "challenge",
    "opt_preview": true,
    "id": "1772572212961-86781-LNymX-challenge",
    "status": "active",
    "opt_cat": "Signet Ring"
  },
  "1772230537877-86781-LNymX-item": {
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "opt_market": true,
    "opt_itemType": "inventory",
    "opt_visible": true,
    "path": "sgqq9h4dqmuxs2kdj8",
    "type": "item",
    "id": "1772230537877-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554116045-Inventory%20Item%20(11).png?alt=media&token=ba00b05b-5742-4579-84d0-25894c91a127",
    "opt_marketPrice": 100,
    "name": "Tabula Rasa (Homework Pass)",
    "ts": 1774793344156,
    "opt_available": true,
    "opt_preview": false,
    "opt_usable": true
  },
  "1772230537886-86781-LNymX-item": {
    "opt_visible": true,
    "path": "4sba9yfjhufcbcmreq",
    "type": "item",
    "opt_itemType": "inventory",
    "opt_market": true,
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "ts": 1774793041224,
    "name": "The Standard of the First Legion",
    "opt_marketPrice": 50,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772308091269-Inventory%20Item%20(6).png?alt=media&token=446851bc-81a0-4b02-9e75-d0fa1c7593ff",
    "id": "1772230537886-86781-LNymX-item"
  },
  "1772568921625-86781-LNymX-badge": {
    "id": "1772568921625-86781-LNymX-badge",
    "opt_cat": null,
    "status": "active",
    "opt_preview": true,
    "type": "badge",
    "opt_available": true,
    "opt_visible": true,
    "path": "7dl_hbob5ezi7wp1ry",
    "ts": 1772568922858,
    "name": "Scribe Velocity (Speed of Script)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568919961-Badge%20Template%20(6).png?alt=media&token=35c46dc2-e9e3-4a5c-8046-0de0452accf4"
  },
  "1772230537878-86781-LNymX-item": {
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "opt_market": true,
    "opt_visible": true,
    "path": "54sq0nyvvuebrw4s9p",
    "type": "item",
    "opt_itemType": "inventory",
    "id": "1772230537878-86781-LNymX-item",
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": false,
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564941724-Inventory%20Item%20(12).png?alt=media&token=19096192-f911-49e3-8280-c8c0e400e266",
    "name": "Tempus Solutum (Free Time)",
    "ts": 1774793356580
  },
  "1772691651374-86781-LNymX-leaderboard": {
    "icon": "/images/icons/leaderboard.png",
    "ts": 1772691855258,
    "name": "Individual XP Leaders",
    "opt_preview": false,
    "opt_available": true,
    "path": "jeos30_-w7bpoj717m",
    "type": "leaderboard",
    "opt_visible": true,
    "status": "active",
    "opt_cat": null,
    "id": "1772691651374-86781-LNymX-leaderboard"
  },
  "1772230537890-86781-LNymX-item": {
    "path": "adcikmh7iw7c4eir23",
    "type": "item",
    "opt_visible": true,
    "opt_itemType": "collectible",
    "status": "active",
    "opt_cat": "The Pantheon's Favor",
    "opt_market": true,
    "opt_preview": true,
    "opt_available": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295099861-Inventory%20Item.png?alt=media&token=0d29ad82-fe6e-4e33-88ee-f8cf6a872b48",
    "opt_marketPrice": 200,
    "ts": 1774792657892,
    "name": "Minerva's Owl",
    "id": "1772230537890-86781-LNymX-item"
  },
  "1772230537867-86781-LNymX-item": {
    "opt_cat": null,
    "status": "active",
    "opt_market": true,
    "type": "item",
    "opt_visible": true,
    "path": "wlbliiikwiqq8zmsoe",
    "opt_itemType": "contribution",
    "id": "1772230537867-86781-LNymX-item",
    "opt_preview": true,
    "opt_available": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566213635-Contribution%20Item%20Template%20(1).png?alt=media&token=d9e40286-146c-4e09-b558-8e84449df37f",
    "opt_marketPrice": null,
    "ts": 1772566215848,
    "name": "Forum Collection: Outside Time"
  },
  "1772568083563-86781-LNymX-badge": {
    "id": "1772568083563-86781-LNymX-badge",
    "opt_cat": null,
    "status": "active",
    "name": "Nocturnal Scholar (Reading for Pleasure)",
    "ts": 1772568445461,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568081970-Badge%20Template%20(1).png?alt=media&token=e7a317e3-c382-4b65-a75c-e67861edcc7c",
    "opt_available": true,
    "path": "tsknlj8l-hsdpqtoz0",
    "type": "badge",
    "opt_visible": true,
    "opt_preview": true
  },
  "1772568608019-86781-LNymX-badge": {
    "opt_preview": true,
    "type": "badge",
    "path": "4xlkt5whenhhkqys57",
    "opt_available": true,
    "opt_visible": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568606661-Badge%20Template%20(3).png?alt=media&token=6c68e9db-42ce-4765-b7a2-7973ab8a61a3",
    "ts": 1772568609248,
    "name": "Grammaticus Maximus (Achievement in Writing)",
    "status": "active",
    "opt_cat": null,
    "id": "1772568608019-86781-LNymX-badge"
  },
  "1772230537885-86781-LNymX-item": {
    "opt_visible": true,
    "type": "item",
    "path": "8ovknxepyw3oaflub1",
    "opt_itemType": "inventory",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Imperial Indulgences",
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "ts": 1774793031022,
    "name": "The Praetorian Pardon",
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307966654-Inventory%20Item%20(5).png?alt=media&token=8b912143-3194-4e0d-a647-9a7e34c2949d",
    "id": "1772230537885-86781-LNymX-item"
  },
  "1772590711756-86781-LNymX-level": {
    "type": "level",
    "path": "-rn4xz-orgd_dbndjt",
    "opt_visible": true,
    "opt_available": true,
    "opt_preview": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597828647-civis.png?alt=media&token=faa1c836-1f43-4563-8d03-5c72b25fa8a5",
    "name": "Civis (The Citizen):",
    "ts": 1772597831490,
    "opt_cat": null,
    "status": "active",
    "id": "1772590711756-86781-LNymX-level",
    "opt_pointMinimum": 500
  },
  "1772569136690-86781-LNymX-badge": {
    "opt_cat": null,
    "status": "active",
    "id": "1772569136690-86781-LNymX-badge",
    "opt_preview": true,
    "type": "badge",
    "opt_available": true,
    "opt_visible": true,
    "path": "2msg0hfem8sa39qin8",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569134967-Badge%20Template%20(7).png?alt=media&token=b8857abb-4adb-4cc6-8173-271778bb98ff",
    "ts": 1772569137960,
    "name": "Cursus Honorum (The Path of Honor)"
  },
  "1772230537874-86781-LNymX-item": {
    "opt_visible": true,
    "path": "jrcu8vuy0747c8ee6f",
    "type": "item",
    "opt_itemType": "inventory",
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "opt_market": true,
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true,
    "opt_marketPrice": 100,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554064109-Inventory%20Item%20(9).png?alt=media&token=24dc2242-4a6e-4408-92ab-e30dc774b072",
    "ts": 1774793258707,
    "name": "Pilleus Libertatis (Hat Pass for a Day)",
    "id": "1772230537874-86781-LNymX-item"
  },
  "1772230537882-86781-LNymX-item": {
    "opt_visible": true,
    "path": "p00nuqc5beu75fkllr",
    "type": "item",
    "opt_itemType": "inventory",
    "opt_cat": "The Imperial Indulgences",
    "status": "active",
    "opt_market": true,
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": true,
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772303244750-Inventory%20Item%20(3).png?alt=media&token=8755aa8b-307b-4316-b462-ce838cacdaf5",
    "name": "The Janus Key",
    "ts": 1774792993109,
    "id": "1772230537882-86781-LNymX-item"
  },
  "1772568758645-86781-LNymX-badge": {
    "id": "1772568758645-86781-LNymX-badge",
    "opt_cat": null,
    "status": "active",
    "ts": 1772568759853,
    "name": "Rhetorics Aegis (Arguments with Aplomb)",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772568757154-Badge%20Template%20(5).png?alt=media&token=266b8e09-33c4-448f-83d7-a25825923100",
    "opt_preview": true,
    "path": "ojrun84qobzszp0ccc",
    "type": "badge",
    "opt_visible": true,
    "opt_available": true
  },
  "1772233183963-86781-LNymX-collection": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772233182186-Collectible.jpg?alt=media&token=1d3d9f0b-182c-424c-83af-957fc7dd64b3",
    "name": "The Pantheons Favor",
    "ts": 1772590464005,
    "type": "collection",
    "path": "lvny1o6jvvvp0_w-3o",
    "opt_available": true,
    "opt_visible": true,
    "opt_preview": true,
    "opt_itemList": [
      "1772230537888-86781-LNymX-item",
      "1772230537891-86781-LNymX-item",
      "1772230537890-86781-LNymX-item",
      "1772230537889-86781-LNymX-item"
    ],
    "opt_cat": null,
    "status": "active",
    "id": "1772233183963-86781-LNymX-collection"
  },
  "1772691991174-86781-LNymX-leaderboard": {
    "status": "active",
    "opt_cat": null,
    "id": "1772691991174-86781-LNymX-leaderboard",
    "opt_visible": true,
    "type": "leaderboard",
    "path": "y7mhyglpykkp23os65",
    "opt_available": true,
    "opt_preview": false,
    "icon": "/images/icons/leaderboard.png",
    "name": "Individual Currency Leaders",
    "ts": 1772691991537
  },
  "1772230537872-86781-LNymX-item": {
    "id": "1772230537872-86781-LNymX-item",
    "opt_available": true,
    "opt_preview": true,
    "name": "One Pencil",
    "ts": 1772566551781,
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564438056-Real%20World%20Item%20Template%20(3).png?alt=media&token=7d3080c2-45c0-4339-98b5-5e4d4e484cde",
    "opt_market": true,
    "status": "active",
    "opt_cat": null,
    "path": "kf8fjsuyfjoqdjamnb",
    "opt_visible": true,
    "type": "item",
    "opt_itemType": "realworld"
  },
  "1772564322752-86781-LNymX-item": {
    "opt_available": true,
    "opt_preview": true,
    "name": "One Soda",
    "ts": 1772564323970,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564321316-Real%20World%20Item%20Template%20(2).png?alt=media&token=937eb80f-707a-47cc-9463-7fa80236ebf4",
    "opt_marketPrice": 300,
    "id": "1772564322752-86781-LNymX-item",
    "opt_visible": true,
    "path": "3989__og6ev6a66jjp",
    "type": "item",
    "opt_itemType": "realworld",
    "opt_market": true,
    "opt_cat": null,
    "status": "active"
  },
  "1772567715658-86781-LNymX-badge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772567714277-Badge%20Template.png?alt=media&token=406a8e5e-f7a9-485d-98dc-6fa77d56ed44",
    "name": "Eloquentia (The Gift of Eloquence)",
    "ts": 1772568474544,
    "type": "badge",
    "path": "q5_sdclod5z5plcp4z",
    "opt_available": true,
    "opt_visible": true,
    "opt_preview": true,
    "status": "active",
    "opt_cat": null,
    "id": "1772567715658-86781-LNymX-badge"
  },
  "1772230537875-86781-LNymX-item": {
    "opt_market": false,
    "status": "active",
    "opt_cat": "Relics of the Empire",
    "type": "item",
    "path": "9mnl229xj3wfi5m9zu",
    "opt_visible": true,
    "opt_itemType": "collectible",
    "id": "1772230537875-86781-LNymX-item",
    "opt_available": true,
    "opt_preview": true,
    "name": "Scroll Fragment",
    "ts": 1774792694642,
    "opt_marketPrice": null,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772299172837-Collectible%20Item%20(4).png?alt=media&token=88f3fba7-6c8a-4625-ba2b-605c7fe6e65b"
  },
  "1772230537868-86781-LNymX-item": {
    "id": "1772230537868-86781-LNymX-item",
    "opt_marketPrice": null,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298748505-Collectible%20Item%20(2).png?alt=media&token=7996ab2e-1ec7-487c-b946-a1c22022daad",
    "name": "Fragment of a Roman Mosaic Tile",
    "ts": 1774792601716,
    "opt_available": true,
    "opt_preview": true,
    "opt_cat": "Relics of the Empire",
    "status": "active",
    "opt_market": false,
    "opt_itemType": "collectible",
    "path": "buulld2uhkury9nhw2",
    "opt_visible": true,
    "type": "item"
  },
  "1772591192992-86781-LNymX-level": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597857170-statesman.png?alt=media&token=acea89fb-3722-441c-872c-28dd52a0bcf2",
    "name": "Senator (The Statesman):",
    "ts": 1772597860074,
    "opt_available": true,
    "opt_visible": true,
    "path": "syao-jbvgv0h6cp8ez",
    "type": "level",
    "opt_preview": true,
    "opt_pointMinimum": 3500,
    "opt_cat": null,
    "status": "active",
    "id": "1772591192992-86781-LNymX-level"
  },
  "1773106682903-86781-LNymX-item": {
    "opt_available": true,
    "opt_preview": true,
    "name": "Pax Romana Lottery",
    "ts": 1773106687913,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1773106680758-Lottery%20(1).png?alt=media&token=2f45d15d-ec16-4e26-a83e-3738bda533f1",
    "opt_marketPrice": 100,
    "id": "1773106682903-86781-LNymX-item",
    "type": "item",
    "path": "nd0fh54v99z7vxjibf",
    "opt_visible": true,
    "opt_itemType": "lottery",
    "opt_market": true,
    "status": "active",
    "opt_cat": null
  },
  "1772230537871-86781-LNymX-item": {
    "id": "1772230537871-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553717485-Inventory%20Item%20(8).png?alt=media&token=c931ffd9-c0a4-4569-b7ca-a34f8fc09913",
    "opt_marketPrice": 100,
    "ts": 1774793230918,
    "name": "Otium Ludi (Free Time)",
    "opt_preview": true,
    "opt_usable": true,
    "opt_available": true,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_market": true,
    "opt_itemType": "inventory",
    "path": "xwmh91xnfhdvp7dosf",
    "type": "item",
    "opt_visible": true
  },
  "1772572157879-86781-LNymX-challenge": {
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572156886-music.png?alt=media&token=e2354199-92c6-4615-923a-92622ba900c3",
    "name": "The Muse's Soundtrack",
    "ts": 1774625569845,
    "type": "challenge",
    "path": "0mtodi8qtrffa3mjfy",
    "opt_available": true,
    "opt_visible": true,
    "opt_preview": true,
    "status": "active",
    "opt_cat": "Signet Ring",
    "id": "1772572157879-86781-LNymX-challenge"
  },
  "1772571725728-86781-LNymX-challenge": {
    "opt_available": true,
    "opt_visible": true,
    "path": "p3qy54745ez9wy2y4q",
    "type": "challenge",
    "opt_preview": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571724680-appian.png?alt=media&token=61febc9d-17f3-462d-b605-d38328bd3d5b",
    "name": "The Appian Way",
    "ts": 1774625418695,
    "opt_cat": "Codex Aureus",
    "status": "active",
    "id": "1772571725728-86781-LNymX-challenge"
  },
  "1772230537866-86781-LNymX-item": {
    "opt_cat": "Relics of the Empire",
    "status": "active",
    "opt_market": false,
    "type": "item",
    "opt_visible": true,
    "path": "uotbcusu0m5fzmcvwk",
    "opt_itemType": "collectible",
    "id": "1772230537866-86781-LNymX-item",
    "opt_preview": true,
    "opt_available": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298423461-Collectible%20Item%20(1).png?alt=media&token=6e85c42c-3199-447d-9685-cdcc07717e5c",
    "opt_marketPrice": null,
    "ts": 1774792591338,
    "name": "Aureus Coin"
  },
  "1772591111727-86781-LNymX-level": {
    "opt_pointMinimum": 1500,
    "id": "1772591111727-86781-LNymX-level",
    "opt_cat": null,
    "status": "active",
    "ts": 1772597845143,
    "name": "Centurion (The Leader):",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597842378-centurion.png?alt=media&token=10ec62e5-a09b-4f12-9938-c1e5dd259b90",
    "opt_preview": true,
    "type": "level",
    "opt_available": true,
    "opt_visible": true,
    "path": "39tlevyjbtc3jnqdpb"
  },
  "1772230537884-86781-LNymX-item": {
    "status": "active",
    "opt_cat": "The Imperial Indulgences",
    "opt_market": true,
    "opt_itemType": "inventory",
    "opt_visible": true,
    "path": "6s54x4tkomnmbwwqij",
    "type": "item",
    "id": "1772230537884-86781-LNymX-item",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772307861026-Inventory%20Item%20(4).png?alt=media&token=990024c3-53a3-4d76-8eb0-12456828de8e",
    "opt_marketPrice": 200,
    "ts": 1774793017047,
    "name": "The Lyre of Orpheus",
    "opt_usable": true,
    "opt_preview": true,
    "opt_available": true
  },
  "1772569257452-86781-LNymX-badge": {
    "id": "1772569257452-86781-LNymX-badge",
    "opt_cat": null,
    "status": "active",
    "type": "badge",
    "opt_available": true,
    "path": "wabxktmejd4m_j0kwj",
    "opt_visible": true,
    "opt_preview": true,
    "name": "Lexicon Legatus (Vocabulary Envoy)",
    "ts": 1772569258766,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569255869-Badge%20Template%20(8).png?alt=media&token=5680f20d-1c2c-4698-8e09-ecf0199074e8"
  },
  "1772590997526-86781-LNymX-prizepack": {
    "opt_cat": null,
    "status": "active",
    "opt_market": true,
    "opt_itemType": "prizepack",
    "type": "item",
    "opt_visible": true,
    "path": "g933gh8skhusoowurr",
    "id": "1772590997526-86781-LNymX-prizepack",
    "opt_marketPrice": 500,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
    "name": "The Tribute Chest",
    "ts": 1772590999403,
    "opt_available": true,
    "opt_preview": true
  },
  "1772569834612-86781-LNymX-challenge": {
    "opt_cat": "Citizen's Tasks",
    "status": "active",
    "id": "1772569834612-86781-LNymX-challenge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569833138-prophecy.png?alt=media&token=d9bbf225-f61a-4a2e-8837-ddeb3ee44ce9",
    "name": "The Sibylline Prophecy",
    "ts": 1774625746647,
    "path": "4zbqmstr9c9jjc24ux",
    "opt_visible": true,
    "type": "challenge",
    "opt_available": true,
    "opt_preview": true
  },
  "1772569770551-86781-LNymX-challenge": {
    "ts": 1774625730762,
    "name": "The Forum Oration",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb",
    "opt_preview": true,
    "path": "60d4y80ktqectdx0xc",
    "opt_visible": true,
    "opt_available": true,
    "type": "challenge",
    "id": "1772569770551-86781-LNymX-challenge",
    "opt_cat": "Citizen's Tasks",
    "status": "active"
  },
  "1772230537873-86781-LNymX-item": {
    "opt_itemType": "realworld",
    "path": "8to74sqtnv8s11c4pz",
    "opt_visible": true,
    "type": "item",
    "status": "active",
    "opt_cat": null,
    "opt_market": true,
    "opt_marketPrice": 50,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564911284-Real%20World%20Item%20Template%20(4).png?alt=media&token=53ab611a-9a04-4534-8c2a-08b15ed5631e",
    "name": "One Piece of Candy",
    "ts": 1772566562625,
    "opt_available": true,
    "opt_preview": true,
    "id": "1772230537873-86781-LNymX-item"
  },
  "1772572068570-86781-LNymX-challenge": {
    "opt_cat": "Signet Ring",
    "status": "active",
    "id": "1772572068570-86781-LNymX-challenge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772572067641-oracle2.png?alt=media&token=0723ea98-34df-4f78-8bd2-00b53f9b61b7",
    "name": "The Oracle's Verse",
    "ts": 1774625473904,
    "opt_visible": true,
    "opt_available": true,
    "path": "atjnzei887cja7sqz5",
    "type": "challenge",
    "opt_preview": true
  },
  "1772566827182-86781-LNymX-item": {
    "id": "1772566827182-86781-LNymX-item",
    "ts": 1772566828397,
    "name": "One Mechanical Pencil",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772566825895-Real%20World%20Item%20Template%20(5).png?alt=media&token=66705a95-f162-4a01-a64e-bfe8fbfac394",
    "opt_marketPrice": 200,
    "opt_preview": true,
    "opt_available": true,
    "opt_market": true,
    "status": "active",
    "opt_cat": null,
    "opt_itemType": "realworld",
    "opt_visible": true,
    "path": "2873x4dc5nbn4xkayw",
    "type": "item"
  },
  "1772590648474-86781-LNymX-level": {
    "opt_pointMinimum": 0,
    "id": "1772590648474-86781-LNymX-level",
    "opt_cat": null,
    "status": "active",
    "name": "Tiro (The Recruit)",
    "ts": 1772597812599,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772597809330-tiro.png?alt=media&token=e0b37601-1580-43b4-a49f-8feb03888fb6",
    "opt_available": true,
    "opt_visible": true,
    "path": "vnzyuvgp-ikz728wnq",
    "type": "level",
    "opt_preview": true
  },
  "1772230537883-86781-LNymX-item": {
    "opt_itemType": "inventory",
    "opt_visible": true,
    "path": "2dluhmmhngk57wts6j",
    "type": "item",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Imperial Indulgences",
    "name": "Apollo’s Laurel",
    "ts": 1774792978326,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772300758021-Inventory%20Item%20(1).png?alt=media&token=5c8323e0-6e0c-4333-9aa5-05066cd46138",
    "opt_marketPrice": 200,
    "opt_available": true,
    "opt_usable": true,
    "opt_preview": true,
    "id": "1772230537883-86781-LNymX-item"
  },
  "1772691604870-86781-LNymX-leaderboard": {
    "icon": "/images/icons/leaderboard.png",
    "ts": 1772691605228,
    "name": "Team Points",
    "opt_preview": false,
    "type": "leaderboard",
    "opt_available": true,
    "path": "700zu5e_4b9nrk22w7",
    "opt_visible": true,
    "status": "active",
    "opt_cat": null,
    "id": "1772691604870-86781-LNymX-leaderboard"
  },
  "1772230537870-86781-LNymX-item": {
    "opt_itemType": "collectible",
    "type": "item",
    "path": "f4qmlefd3a7a9gl2bn",
    "opt_visible": true,
    "status": "active",
    "opt_cat": "Relics of the Empire",
    "opt_market": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772298861728-Collectible%20Item%20(3).png?alt=media&token=32fbd18f-1bb6-43bd-8dcc-bc6e489ebec9",
    "opt_marketPrice": 300,
    "ts": 1774792744773,
    "name": "Miniature Legionary Helmet",
    "opt_preview": true,
    "opt_available": true,
    "id": "1772230537870-86781-LNymX-item"
  },
  "1772571789776-86781-LNymX-challenge": {
    "status": "active",
    "opt_cat": "Codex Aureus",
    "id": "1772571789776-86781-LNymX-challenge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571788594-amphitheater.png?alt=media&token=6d415076-c1b0-426a-adc3-380ed60f1b6e",
    "name": "Amphitheater Critique",
    "ts": 1774625435255,
    "opt_available": true,
    "opt_visible": true,
    "type": "challenge",
    "path": "dfh85yv_3oew-6d2oj",
    "opt_preview": true
  },
  "1772230537876-86781-LNymX-item": {
    "opt_market": true,
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "type": "item",
    "path": "tm5yh27gmuxldw0vky",
    "opt_visible": true,
    "opt_itemType": "inventory",
    "id": "1772230537876-86781-LNymX-item",
    "opt_available": true,
    "opt_preview": true,
    "opt_usable": true,
    "name": "Sella Curulis (Special Chair for a Day)",
    "ts": 1774793333472,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772554085909-Inventory%20Item%20(10).png?alt=media&token=4a453739-b714-480d-985a-84794eab7cdd",
    "opt_marketPrice": 100
  },
  "1772569886040-86781-LNymX-challenge": {
    "id": "1772569886040-86781-LNymX-challenge",
    "opt_cat": "Citizen's Tasks",
    "status": "active",
    "type": "challenge",
    "path": "29bwi-ah-6h4cpdhvk",
    "opt_available": true,
    "opt_visible": true,
    "opt_preview": true,
    "name": "Veni, Vidi, Vici",
    "ts": 1774625766547,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945"
  },
  "1772230537880-86781-LNymX-item": {
    "id": "1772230537880-86781-LNymX-item",
    "opt_available": true,
    "opt_preview": true,
    "opt_usable": true,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772306786854-Access%20Item%20(2).png?alt=media&token=d6bcc89e-6c1d-4a69-b47b-d57202dd2d1b",
    "opt_marketPrice": null,
    "name": "The Codex Aureus",
    "ts": 1774792117506,
    "opt_cat": "Access Granted",
    "status": "active",
    "opt_market": false,
    "opt_visible": true,
    "type": "item",
    "path": "w16qizffa7qgin0m6d",
    "opt_itemType": "inventory"
  },
  "1772230537891-86781-LNymX-item": {
    "opt_market": false,
    "opt_cat": "The Pantheon's Favor",
    "status": "active",
    "opt_visible": true,
    "path": "8lj8mddumue47fm72d",
    "type": "item",
    "opt_itemType": "collectible",
    "id": "1772230537891-86781-LNymX-item",
    "opt_preview": true,
    "opt_available": true,
    "ts": 1774792645379,
    "name": "Mercury's Winged Sandal",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772295414866-final-sandal.png?alt=media&token=72853a72-1622-45c1-aae9-f5d9dea654dc",
    "opt_marketPrice": null
  },
  "1772230537879-86781-LNymX-item": {
    "opt_itemType": "inventory",
    "path": "zv3k5vokbz365u7izg",
    "type": "item",
    "opt_visible": true,
    "opt_market": true,
    "opt_cat": "The Prerogatives of the Citizen",
    "status": "active",
    "name": "Abacus of the Architect",
    "ts": 1774793318209,
    "opt_marketPrice": 200,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564972120-Inventory%20Item%20(13).png?alt=media&token=d82cc334-3bc9-49a7-a89d-13608f1b7dba",
    "opt_available": true,
    "opt_preview": true,
    "opt_usable": true,
    "id": "1772230537879-86781-LNymX-item"
  },
  "1772230537869-86781-LNymX-item": {
    "opt_visible": true,
    "path": "ivuby781ayvjwfzeqq",
    "type": "item",
    "opt_itemType": "inventory",
    "opt_market": true,
    "status": "active",
    "opt_cat": "The Prerogatives of the Citizen",
    "opt_available": true,
    "opt_preview": true,
    "opt_usable": true,
    "name": "Magister's Legatus (Teacher's Helper for a Day)",
    "ts": 1774793209337,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772553695485-Inventory%20Item%20(7).png?alt=media&token=720d5f6e-2ad6-4c50-82b8-de7fe34d7874",
    "opt_marketPrice": 100,
    "id": "1772230537869-86781-LNymX-item"
  },
  "1772590433659-86781-LNymX-collection": {
    "opt_available": true,
    "opt_visible": true,
    "path": "zt754wr-1mz0xozfu7",
    "type": "collection",
    "opt_preview": true,
    "opt_itemList": [
      "1772230537866-86781-LNymX-item",
      "1772230537868-86781-LNymX-item",
      "1772230537870-86781-LNymX-item",
      "1772230537875-86781-LNymX-item"
    ],
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590432691-Collection%20Template.png?alt=media&token=730a0a9f-93f2-42e7-9ff3-6936dee5992b",
    "name": "Relics of the Empire",
    "ts": 1772590438600,
    "opt_cat": null,
    "status": "active",
    "id": "1772590433659-86781-LNymX-collection"
  },
  "1772563864434-86781-LNymX-item": {
    "opt_itemType": "realworld",
    "opt_visible": true,
    "path": "3i9b_9edz20rizm6k-",
    "type": "item",
    "opt_market": true,
    "opt_cat": null,
    "status": "active",
    "name": "One Snack Item",
    "ts": 1772564142589,
    "opt_marketPrice": 300,
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772564140348-Real%20World%20Item%20Template%20(1).png?alt=media&token=4bf0c1e3-fa04-4e0f-a0de-f3a64555b99d",
    "opt_available": true,
    "opt_preview": true,
    "id": "1772563864434-86781-LNymX-item"
  },
  "1772571898963-86781-LNymX-challenge": {
    "status": "active",
    "opt_cat": "Codex Aureus",
    "id": "1772571898963-86781-LNymX-challenge",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772571897664-scroll.png?alt=media&token=654bf7ec-4a07-4d74-95af-4519c85f3b38",
    "ts": 1774625452310,
    "name": "Scriptorium Scroll",
    "opt_preview": true,
    "opt_available": true,
    "opt_visible": true,
    "path": "iyxgdj9yb4he-5t60z",
    "type": "challenge"
  }
}